import {createReducer} from "./index";
import * as R from 'ramda';
import {ADD_FILES, API_DELETE_FILE_DONE, API_GET_SINGLE_FILE_DONE, SET_UPLOAD_FILE_STATUS} from "../actions/files";
import {BID, DAILYLOG, MEETINGMINUTES, PROJECT, PUNCHLIST, RFI, SUBMITTAL, TASK} from "../services";

const filesInitial = {
  data: {},
  indexes: {
    bid: {},
    project: {},
    submittal: {},
    task: {},
    projectrfi: {},
    punchlistitem: {},
    dailylog: {},
    meetingminutes: {}
  }
};

function addFiles(state, files) {
  let newState = state;
  files.forEach(file => {
    if (!file) return;
    newState = R.over(R.lensPath(['data', file.id]), () => file)(newState);
    newState = R.over(R.lensPath(['indexes', file.associationtype, file.associatedid]), value => {
      if (!value) {
        return {[file.id]: 1};
      } else {
        return {...value, [file.id]: 1};
      }
    })(newState);
  });
  return newState;
}

function removeFileById(state, fileId) {
  let file = state.data[fileId];
  let newState = state;
  newState = R.dissocPath(['data', file.id], newState);
  newState = R.dissocPath(['indexes', file.associationtype, file.associatedid, file.id], newState);
  return newState;
}

const filesReducer = createReducer(filesInitial, {
  [ADD_FILES]: (state, action) => addFiles(state, action.payload),
  [API_DELETE_FILE_DONE]: (state, action) => removeFileById(state, action.payload.fileId),
  [API_GET_SINGLE_FILE_DONE]: (state, action) => addFiles(state, [action.payload.response]),
  [SET_UPLOAD_FILE_STATUS]: (state, action) => {
    const getType = type => {
      if (type === BID) { return 'bid'; }
      if (type === PROJECT) { return 'project'; }
      if (type === SUBMITTAL) { return 'submittal'; }
      if (type === RFI) { return 'projectrfi'; }
      if (type === TASK) { return 'task'; }
      if (type === PUNCHLIST) { return 'punchlistitem'; }
      if (type === DAILYLOG) { return 'dailylog'; }
      if (type === MEETINGMINUTES) { return 'meetingminutes'; }
    };
    const { metadata: { name }, type, id, subId, loading } = action.payload;
    const parsedType = getType(type);
    const path = ['indexes', parsedType, [BID, PROJECT].includes(type) ? id : subId, 'metadata'];
    let newState = state;
    newState = R.set(R.lensPath([...path, name]), loading, newState);
    newState = R.set(R.lensPath([...path, 'loading']), Object.values(R.omit(['loading'], R.path(path, newState))).filter(i => i).length > 0, newState);
    return newState;
  },
});

export default filesReducer;



// WEBPACK FOOTER //
// ./src/reducers/files.js